<script setup lang="ts">
    import type { IntroWidgetData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    defineProps<IWidgetProps<IntroWidgetData>>();
</script>
<template>
    <org-intro-widget
        :data="data"
        class="cms-intro-widget" />
</template>
